import { motion } from "framer-motion";

/**
 * Simple reveal that animates on mount. Reliable across all viewports
 * and avoids IntersectionObserver edge cases on initial page load.
 */
export default function Reveal({
    children,
    delay = 0,
    y = 24,
    duration = 1.0,
    className = "",
}) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
                duration,
                delay,
                ease: [0.16, 1, 0.3, 1],
            }}
            className={className}
        >
            {children}
        </motion.div>
    );
}
